import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/service/${dossierId}/related`, method: 'GET', token: token })
}
